import { render } from "./CreateSoftwareDocumentationComponent.vue?vue&type=template&id=5a2555a2"
import script from "./CreateSoftwareDocumentationComponent.vue?vue&type=script&lang=js"
export * from "./CreateSoftwareDocumentationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__